import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { RotacionPesajeVeterinariaService } from "../../../../generated/grpc/pesaje_ganaderia_pb";
import { grpcRotacionPesajeVeterinariaDatabase } from "../database/GrpcRotacionPesajeVeterinariaDatabase";
import { RotacionPesajeVeterinariaRequest } from "../request/RotacionPesajeVeterinariaRequest";
import { RotacionPesajeVeterinariaResponse } from "../response/RotacionPesajeVeterinariaResponse";
import { fx_aplicarCambiosMovimientoAsync } from "./aplicarCambiosMovimiento";
import { toRotacionPesajeVeterinariaResponse } from "./RotacionPesajeVeterinariaGrpcService";

/** Variante gRPC-Web de `RotacionPesajeVeterinariaSaveService` (ver ese
 *  archivo): mismo guardado crear-o-actualizar. Escribe además los lotes
 *  (origen, destino y destino anterior) y las compras que el server
 *  recalculó, que vienen en la misma respuesta -ver
 *  `fx_aplicarCambiosMovimientoAsync`- (2026-10-08). */
export class RotacionPesajeVeterinariaSaveGrpcService
  implements
    ISaveService<
      RotacionPesajeVeterinariaRequest,
      RotacionPesajeVeterinariaResponse
    >
{
  async saveAsync(
    request: RotacionPesajeVeterinariaRequest,
  ): Promise<RotacionPesajeVeterinariaResponse> {
    const client = createClient(RotacionPesajeVeterinariaService, grpcTransportProvider.get());

    let respuesta;
    try {
      respuesta = await client.guardar({
        id: request.id ?? undefined,
        loteOrigenId: request.loteOrigenId,
        loteDestinoId: request.loteDestinoId ?? undefined,
        fecha: request.fecha,
        cantidadAnimales: request.cantidadAnimales,
        isRotacion: request.isRotacion,
        isPesaje: request.isPesaje,
        isVeterinaria: request.isVeterinaria,
        pesosAnimales: request.pesosAnimales,
        procedimientoIds: request.procedimientoIds,
        vetObservaciones: request.vetObservaciones ?? undefined,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    const saved = respuesta.evento;
    if (!saved) {
      throw new Error("El servidor no devolvió el evento guardado.");
    }

    await grpcRotacionPesajeVeterinariaDatabase.putOneAsync(saved);
    await fx_aplicarCambiosMovimientoAsync(respuesta);
    return toRotacionPesajeVeterinariaResponse(saved);
  }
}
